import Vue from "vue";
import Router from "vue-router";

import HomeView from "../views/HomeView.vue";
import MyPoolView from "../views/MyPoolView.vue";
import TradeView from "../views/TradeView.vue";
import ShareView from "../views/ShareView.vue";
import AccountView from "../views/AccountView.vue";
import ServiceView from "../views/ServiceView.vue";
import RecordsView from "../views/RecordsView.vue";
import SignView from "../views/SignView.vue";
import LegalContractView from "../views/LegalContractView.vue";

Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [
    { path: "/", component: HomeView },
    { path: "/myPool", component: MyPoolView },
    { path: "/trade", component: TradeView },
    { path: "/share", component: ShareView },
    { path: "/account", component: AccountView },
    { path: "/service", component: ServiceView },
    { path: "/records", component: RecordsView },
    { path: "/sign", component: SignView },
    // 律师事务所合同页暂时隐藏，仅保留可通过 /legal 直接访问
    { path: "/legal", component: LegalContractView },
    { path: "*", redirect: "/" },
  ],
});
